import { z } from 'zod';
import { adminAuditFieldsSchema } from './IAdminAudit';

export const reservationStatusSchema = z.object({
    id: z.number().default(1),
    name: z.string().default('Angefragt'),
});

export const reservationSchema = z.object({
    id: z.number().default(-1),
    start_date: z.string().default('0000-00-00'),
    end_date: z.string().default('0000-00-00'),
    booking_reason: z.string().default(''),
    notes: z.string().nullable().optional().default(''),
    account: z.number().default(-1),

    booking_status_id: z.number().default(1),
    booking_status: reservationStatusSchema.optional(),

    amount_rooms : z.number().default(1),

    created_at: z.string().optional(), // ISO-DateTime-String vom Backend
}).merge(adminAuditFieldsSchema);

export type IReservation = z.infer<typeof reservationSchema>;
export type IReservationStatus = z.infer<typeof reservationStatusSchema>;
